define('modules/profiles/models/card.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function (_, Backbone, BaseModel) {
    var BoardCardModel = BaseModel.extend({
        base: 'board/card',
        urlRoot:function(){
            return window.utils.makeUrl('prospector/v1/' + this.base + '/' + this.get('boardId'));
        },
        canModifyCard:function(){
            return this.has('id');
        }
    });
    return BoardCardModel;
});

